import React from "react";
import { Helmet } from "react-helmet-async";

const Loading = () => (
  <React.Fragment>
    <Helmet title="Loading..." />
    <div className="text-center">
      <h1 className="display-1 fw-bold">Loading...</h1>
      <p className="h1">Please wait...</p>
    </div>
  </React.Fragment>
);

export default Loading;
